import { render, staticRenderFns } from "./page-navbar.vue?vue&type=template&id=f753d632&scoped=true"
import script from "./page-navbar.vue?vue&type=script&lang=js"
export * from "./page-navbar.vue?vue&type=script&lang=js"
import style0 from "./page-navbar.vue?vue&type=style&index=0&id=f753d632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753d632",
  null
  
)

export default component.exports